import { render, staticRenderFns } from "./Traducoes.vue?vue&type=template&id=734a2d10"
import script from "./Traducoes.vue?vue&type=script&lang=js"
export * from "./Traducoes.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports